import styled from '@emotion/styled';

import CircularLoading from 'components/loading/CircularLoading';

type AdditionalLoadingProps = {
  height: `${number}px` | `${number}%`;
};
export const AdditionalLoading = ({ height }: AdditionalLoadingProps) => {
  return (
    <SAdditionalLoading $height={height}>
      <CircularLoading />
    </SAdditionalLoading>
  );
};

type SAdditionalLoadingProps = {
  $height: `${number}px` | `${number}%`;
};
const SAdditionalLoading = styled.div<SAdditionalLoadingProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ $height }) => `${$height}`};
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;
